import {
  type IGetConfigResponse,
  type IGetCourseFormOptionsResponse,
  type IGetTimezonesResponse
} from '@libs/models';

import { BaseApi, type Result } from './api-client';

export type DatacenterModel = {
  id: number;
  name: string;
  location: string;
};

export type OrganizationModel = {
  id: number;
  name: string;
  createdAt: string;
};

export type TimezoneModel = {
  id: string;
  label: string;
};

export type SelectItem = {
  id: string;
  label: string;
  description?: string;
};

export interface GetTimezonesResponse {
  timezones: TimezoneModel[];
}

export interface GetCourseFormOptionsResponse {
  datacenters: Array<{
    id: number;
    name: string;
  }>;
  organizations: Array<{
    id: number;
    name: string;
  }>;
  timezones: TimezoneModel[];
}

export class ConfigApi extends BaseApi {
  protected readonly baseUrl = '/api/config';

  async getConfig(): Promise<Result<IGetConfigResponse>> {
    return this.get<IGetConfigResponse>('', null, 'Get config failed');
  }

  async getCourseFormOptions(): Promise<Result<IGetCourseFormOptionsResponse>> {
    return this.get<IGetCourseFormOptionsResponse>(
      '/course-form-options',
      null,
      'Get course form options failed'
    );
  }

  async getTimezones(): Promise<Result<IGetTimezonesResponse>> {
    return this.get<IGetTimezonesResponse>('/timezones', null, 'Get timezones failed');
  }

  datacentersToSelectItems(datacenters: DatacenterModel[]): SelectItem[] {
    return datacenters.map(datacenter => ({
      id: datacenter.id.toString(),
      label: `${datacenter.name} (${datacenter.location})`,
      description: datacenter.location
    }));
  }

  organizationsToSelectItems(organizations: OrganizationModel[]): SelectItem[] {
    return organizations.map(organization => ({
      id: organization.id.toString(),
      label: organization.name,
      description: organization.createdAt
    }));
  }

  timezonesToSelectItems(timezones: TimezoneModel[]): SelectItem[] {
    return timezones.map(timezone => ({
      id: timezone.id,
      label: timezone.label,
      description: `IANA: ${timezone.id}`
    }));
  }
}

export const configApi = new ConfigApi();
